import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TabService } from '../../../../tabconfig/tab.service';
import { Tab } from '../../../../tabconfig/tab.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../../common/dialog.service';
import { EmployeeAddComponent } from '../employee-add/employee-add.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmployeeService } from '../../../../api/Services/maintenance/employee.service';
import { AuthService } from '../../../../system/auth.service';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {

  @Input() data;
  public displayedColumns: string[] = ['per_vc_document_number', 'per_vc_full_names', 'emp_vc_status', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('paginatorDatasource', {read: MatPaginator, static: true}) paginator: MatPaginator;
   
  public form: FormGroup;
  parameters: any[];
  constructor(
    private formBuilder: FormBuilder,
    private employeeServices: EmployeeService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private tabService: TabService,
    private authService : AuthService
  ) { }

  ngOnInit(): void {

    this.initForm();
    this.loadInitial();
  }

  public loadInitial() {
    this.parameters = this.authService.getParameters();
  }
  public initForm() {
    this.form = this.formBuilder.group({
      pi_per_in_document_type: 0,
      pi_per_vc_document_number: ' ',
      pi_emp_in_status: 0
    });
  }

  public nuevo(){
    this.tabService.addTab(new Tab(EmployeeAddComponent, "Nuevo Instructor", { parent: 'ListadoComponent' }));
  }

  public listar(){

    
    console.log(this.form.getRawValue());
    this.employeeServices.GetAll(this.form.getRawValue().pi_per_in_document_type,this.form.getRawValue().pi_per_vc_document_number,this.form.getRawValue().pi_emp_in_status).subscribe(
      data => {
        console.log(data)

        this.dataSource = new MatTableDataSource<any[]>(data["data"]);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
          /*
        if(data.code == 100){
          this.dataSource = new MatTableDataSource<any[]>(data.result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }else{
          this.toastr.error(data.message, "Error");
        }
        */
      }
    );

  }

  public buscar()
  {
    this.listar();
  }

  public editar(element){
    this.tabService.removeTab(this.data.id - 1)
    //element.estadoCheck = false;
    this.tabService.addTab(new Tab(EmployeeAddComponent, "Editar Instructor", { parent: 'ListadoComponent', element: element }));
  }

  public eliminar(id){
    this.dialogService.openConfirmDialog('¿Seguro de eliminar al Instructor?')
      .afterClosed().subscribe(res =>{
      if(res){
        this.employeeServices.Delete(id).subscribe(
          data => {
            console.log(data);
            this.listar();
            this.toastr.success('Se eliminó este registro.', 'Correcto');
          }
        );
      }
    });
  }

  public activar(element){
    this.dialogService.openConfirmDialog('¿Seguro de activar este registro?')
    .afterClosed().subscribe(res =>{
    if(res){
      element.emp_in_status = 1;
      this.employeeServices.Update_Status(element).subscribe(
        data => {
          console.log(data);
          this.listar();
          this.toastr.success('Se activo la correctamente.', 'Correcto');
        }
      );
    }
  });
  }

}
